<template>
  <!-- 仕入先支払一覧 -->
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div>
        <!-- ボタン -->
        <t-row>
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 新規 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.sys.newBuilt") }}
            </t-button></t-col
          >

          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="DeleteClickSelected"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.sys.delete") }}
            </t-button></t-col
          >

          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 勘定書出力 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="accountOutputBtn"
              @click="accountOutputDialog()"
            >
              <i class="el-icon-download"></i>
              {{ $t("resource.CUSTOMER_PAY.STATEMENT_ACCOUNT") }}
            </t-button>
          </t-col>
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.search.labelWidth')"
            >
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="13">
                  <div>
                    <!-- 支払予定日/支払日 -->
                    <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- 課題_支払日と請求日の変更 -->
                    <!--  <t-form-item class="dateLabelWidth"
                      " label-width="180px">
                      <span slot="label">
                        <div style="margin-top: 1px">
                          <t-radio-group
                            v-model="payDateLabel"
                            size="small"
                            style="margin-right: 5px"
                          >
                            <t-radio-button label="1">{{
                              $t("resource.CUSTOMER_PAY.PAY_EXPECTED_DATE")
                            }}</t-radio-button>
                            <t-radio-button label="2">{{
                              $t("resource.CUSTOMER_PAY.PAY_DATE")
                            }}</t-radio-button>
                          </t-radio-group>
                        </div>
                      </span> -->
                    <t-form-item
                      label-width="90px"
                      :label="$t('resource.CUSTOMER_PAY.PAY_CRE_DATE')"
                    >
                      <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                      <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        style="min-width: 20px; width: 75%; margin-left: -10px"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy/MM/dd"
                        format="yyyy/MM/dd"
                        :editable="false"
                        :clearable="false"
                        class="date_icon_center"
                      >
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>
                <t-col :span="5">
                  <!-- 状態 -->
                  <t-form-item :label="$t('resource.orderInfo.status')">
                    <t-select
                      v-model="searchConditionForm.searchStatus"
                      clearable
                      style="width: 100%"
                      :placeholder="$t('resource.sys.hidden')"
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <t-col :span="2">&nbsp;</t-col>
              </t-row>
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="18" class="col_block_left">
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      class="input_searchKey"
                      maxlength="50"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="4" class="right">
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    class="button_common_search marginRight"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <div class="div_content">
        <t-table
          ref="customerPayTableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="DetailClick"
          :height="maxheight"
          border
        >
          <t-table-column type="selection" class-name="cell_txt_center" />

          <!-- 状態 -->
          <t-table-column
            prop="pbStatus"
            :label="$t('resource.CUSTOMER_PAY.PAY_STATUS')"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.CUSTOMER_PAY.PAY_STATUS'),
                'pbStatus'
              )
            "
            class-name="cell_txt_center"
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span :class="formatStatusColor(row)" class="status">●</span>
                <span class="order-status">{{ row.pbStatus }} </span>
              </div>
            </template>
          </t-table-column>

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>
        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="GetPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="customerPayTableDatalength"
          @current-change="PageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>
<script>
import {
  ShowAccountOutputDialog,
  ShowCustomerPayEditDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import {
  deleteCustPayBasicByPayNo,
  initCustPaySearchList,
  searchCustPayBasic,
} from "@/services/customerPayInfo";
import {
  formatCurDateToString,
  formatStringToCurrency,
  getPreviousMonthDate,
} from "@/utils/comFunction";
import { GetPageDataCount, STR_EMPTY } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      dateRange: [],
      searchConditionForm: {
        searchStartDate: "",
        searchEndDate: "",
        isPayExpDate: "",
        searchStatus: "",
        searchWord: "",
      },
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_支払日と請求日の変更
      // payDateLabel: "1",
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //ターブルデータ
      customerPayTableData: [],

      //支払状態
      statusList: [],

      columns: [
        // 仕入先
        {
          prop: "pbSupCode",
          label: t("resource.CUSTOMER_PAY.SUPPLIER_COMPANY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_支払日と請求日の変更
        // // 支払予定日
        // {
        //   prop: "pbPayExpectedDate",
        //   label: t("resource.CUSTOMER_PAY.PAY_EXPECTED_DATE"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        //   overflowTooltip: true,
        // },
        // // 支払日
        // {
        //   prop: "pbPayDate",
        //   label: t("resource.CUSTOMER_PAY.PAY_DATE"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        //   overflowTooltip: false,
        // },

        // 支払作成日
        {
          prop: "pbPayExpectedDate",
          label: t("resource.CUSTOMER_PAY.PAY_CRE_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // 支払金額(CNY)
        {
          prop: "pbAmount",
          label: t("resource.CUSTOMER_PAY.PAY_AMOUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },

        // 連絡担当
        {
          prop: "pbUserCode",
          label: t("resource.CUSTOMER_PAY.CONNECTER"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 備考
        {
          prop: "pbRemarks",
          label: t("resource.CUSTOMER_PAY.REMARKS"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
      ],
      showFlag: false,
      // 現在のページ数
      pageNo: 1,
      // データ個数/各ページ
      pageSize: 20,
      customerPayTableDatalength: 0,
      maxheight: window.innerHeight - 291.5 - 10, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    };
  },

  mounted() {
    //画面の初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    setColumnWidth(this.customerPayTableData);
    this.customerPayTableDatalength = this.customerPayTableData.length;
  },

  computed: {
    tableData() {
      return this.customerPayTableData.slice(
        (this.pageNo - 1) * this.pageSize,
        this.pageNo * this.pageSize
      );
    },
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 - 10; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },

    // 初期化
    init() {
      this.showFlag = true;
      //検索条件リストの初期化(状態、支払状態)
      initCustPaySearchList()
        .then((res) => {
          //支払状態のリスト
          this.statusList = res.payStatusList;
          //日付初期化
          this.dateInit();
          //検索処理
          this.searchClick();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        });
      // 列幅に自動調整
      setColumnWidth(this.columns, this.customerPayTableData);
    },

    //支払予定日・支払日の初期化
    dateInit() {
      //システム日付
      var systemDate = new Date();
      //日付初期値の設定
      this.dateRange = [getPreviousMonthDate(systemDate), systemDate];
    },

    // 検索
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      //検索条件の処理
      this.updateSearchForm();

      //検索支払基本情報
      searchCustPayBasic(this.searchConditionForm)
        .then((res) => {
          this.customerPayTableData = res;
          this.customerPayTableDatalength = res.length;

          // データ処理
          this.dataProcess();
          setColumnWidth(this.columns, this.customerPayTableData);

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //データの処理
    dataProcess() {
      if (this.customerPayTableData.length >= 1) {
        this.customerPayTableData.map((item) => {
          //支払予定日が空のチェック
          item.pbPayExpectedDate = formatCurDateToString(
            item.pbPayExpectedDate
          );

          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_支払日と請求日の変更
          // 支払日が空のチェック
          // item.pbPayDate = formatCurDateToString(item.pbPayDate);
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          //金額(CNY)
          item.pbAmount = formatStringToCurrency(parseInt(item.pbAmount));
        });
      }
    },

    updateSearchForm() {
      //スペースを削除
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_支払日と請求日の変更
      // 日付チェック区分の設定
      // this.searchConditionForm.isPayExpDate =
      //   this.payDateLabel === STR_ONE ? true : false;
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //日付が空でない場合
      if (this.dateRange) {
        //支払予定日(開始)
        this.searchConditionForm.searchStartDate = formatCurDateToString(
          this.dateRange[0]
        );
        //支払予定日(終了)
        this.searchConditionForm.searchEndDate = formatCurDateToString(
          this.dateRange[1]
        );
      } else {
        this.searchConditionForm.searchStartDate = STR_EMPTY;
        this.searchConditionForm.searchEndDate = STR_EMPTY;
      }
    },

    //複数行データの削除
    DeleteClickSelected() {
      let data = this.$refs.customerPayTableData.selection;
      var deleteFlg = true;

      if (data.length >= 1) {
        let delList = [];

        // 支払予定データが削除可能、支払済みデータが削除不可
        for (let index = 0; index < data.length; index++) {
          let dataStatus = data[index].pbStatus;
          //   if (dataStatus !== STR_PAY_PLAN) {
          //     Message.showError(t("message.CUS_PAY.NOT_DELETE"), null);
          //     deleteFlg = false;
          //     break;
          //   }
          delList.push(data[index].pbPayNo);
        }

        if (deleteFlg) {
          Modal.showWarning("", t("resource.sys.deleteMessage"), {
            $type: "prompt",
            confirmButtonText: t("resource.button.sure"),
            cancelButtonText: t("resource.button.cancel"),
            showCancelButton: true,
          }).then(() => {
            if (!this.showFlag) {
              this.showFlag = true;
            }
            deleteCustPayBasicByPayNo(delList)
              .then(() => {
                //削除成功
                Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
              })
              .catch((err) => {
                // console.log(err);
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
                }
                this.showFlag = false;
              })
              .finally(() => {
                //検索処理を行う
                this.searchClick();
              });
          });
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      if (typeof this.$refs.delBtn !== "undefined") {
        // フォーカス削除
        this.$refs.delBtn.$el.blur();
      }
    },

    // 新規
    addClick() {
      ShowCustomerPayEditDialog(
        {
          isAdd: true,
        },
        t("resource.CUSTOMER_PAY.CUS_PAY_EDIT_DIALOG"),

        this.searchClick
      );
      // フォーカス削除
      this.$refs.addBtn.$el.blur();
    },

    //詳細
    DetailClick(row) {
      ShowCustomerPayEditDialog(
        {
          isAdd: false,
          rowData: row,
        },
        t("resource.CUSTOMER_PAY.CUS_PAY_EDIT_DIALOG"),
        this.searchClick
      );
    },

    accountOutputDialog() {
      ShowAccountOutputDialog(
        {
          isAdd: true,
        },
        t("resource.CUSTOMER_PAY.STATEMENT_ACCOUNT_DIALOG"),
        this.searchClick
      );
      // フォーカス削除
      this.$refs.accountOutputBtn.$el.blur();
    },

    //出力
    OutPutClick() {
      this.$message("「出力」ボタン");
    },

    // ページング処理
    PageChange(val) {
      this.pageNo = val;
    },
    //毎ページ件数の設定
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },
    TableSort(column) {
      this.pageNo = 1;
      masterService.TableSort(this.customerPayTableData, column);
    },
    // ページあたりのデータ数
    GetPageDataCountFunc() {
      return GetPageDataCount();
    },

    //列幅に自動調整
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.customerPayTableData);
    },

    //状態背景色
    formatStatusColor(row) {
      if (!!row.statusColor) {
        return row.statusColor;
      }
    },
  },
};
</script>
<style lang="scss" scope>
.order-status {
  flex: 1;
}
</style>
